module.exports = __webpack_public_path__ + "static/media/pradenW.4d69ad13.png";